import React, { useMemo, useState } from "react";
import { Fade } from "react-awesome-reveal";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation, Autoplay, Keyboard } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

import "../styles/Gallery.scss";

// ✅ 20 imágenes (nómbralas 1.jpg ... 20.jpg en /images/gallery/)
import g1 from "../images/gallery/1.jpg";
import g2 from "../images/gallery/2.jpg";
import g3 from "../images/gallery/3.jpg";
import g4 from "../images/gallery/4.jpg";
import g5 from "../images/gallery/5.jpg";
import g6 from "../images/gallery/6.jpg";
import g7 from "../images/gallery/7.jpg";
import g8 from "../images/gallery/8.jpg";
import g9 from "../images/gallery/9.jpg";
import g10 from "../images/gallery/10.jpg";
import g11 from "../images/gallery/11.jpg";
import g12 from "../images/gallery/12.jpg";
import g13 from "../images/gallery/13.jpg";
import g14 from "../images/gallery/14.jpg";
import g15 from "../images/gallery/15.jpg";
import g16 from "../images/gallery/16.jpg";
import g17 from "../images/gallery/17.jpg";
import g18 from "../images/gallery/18.jpg";
import g19 from "../images/gallery/19.jpg";
import g20 from "../images/gallery/20.jpg";

const Gallery = () => {
  const images = useMemo(
    () => [
      g1,g2,g3,g4,g5,g6,g7,g8,g9,g10,
      g11,g12,g13,g14,g15,g16,g17,g18,g19,g20
    ],
    []
  );

  // ✅ captions cortos (se reutilizan si hay más imágenes)
  const captions = useMemo(
    () => [
      "Sabor al carbón que se nota.",
      "Montaje profesional y atención al detalle.",
      "Eventos residenciales con experiencia premium.",
      "Reuniones empresariales sin preocupaciones.",
      "Carne al punto, servicio impecable.",
      "Momentos que se disfrutan en grande.",
      "Calidad, presentación y ritmo de servicio.",
      "Tu evento, con un chef profesional en sitio.",
      "Experiencia completa: sabor + montaje.",
      "Clientes felices, eventos memorables.",
      "Banquetes que impresionan desde el inicio.",
      "Servicio puntual y organizado.",
      "Ambiente, sabor y atención top.",
      "Todo listo para que tú solo disfrutes.",
      "Detalles que marcan la diferencia.",
      "Un evento bien servido se recuerda.",
      "Cortes y guarniciones para compartir.",
      "Estilo Pixbae: carbón y calidad.",
      "Eventos con invitados satisfechos.",
      "La experiencia premium que buscabas."
    ],
    []
  );

  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <section className="gallerySection" id="galeria">
      <div className="galleryWrap">
        <Fade triggerOnce>
          <header className="galleryHeader">
            <h2 className="galleryTitle">
              Galería de eventos <span>Pixbae Banquetes</span>
            </h2>
            <p className="gallerySubtitle">
              Algunas imágenes de nuestros eventos para que conozcas el estilo,
              el montaje y la experiencia que llevamos a tu reunión.
            </p>

            <div className="galleryBadges">
              <span className="badgeItem">🔥 Banquetes al carbón</span>
              <span className="badgeItem">📍 GDL · Zapopan · Tlajomulco</span>
              <span className="badgeItem">✨ Servicio premium</span>
            </div>
          </header>
        </Fade>

        <div className="galleryCard">
          <div className="galleryTopRow">
            <div className="galleryHint">
              Desliza para ver más fotos
              <span className="dot" />
              <span className="small">20 imágenes</span>
            </div>

            <div className="galleryCount">
              <span className="current">{activeIndex + 1}</span>
              <span className="sep">/</span>
              <span className="total">{images.length}</span>
            </div>
          </div>

          <Swiper
            modules={[Pagination, Navigation, Autoplay, Keyboard]}
            spaceBetween={16}
            slidesPerView={1}
            loop
            navigation
            keyboard={{ enabled: true }}
            autoplay={{ delay: 3200, disableOnInteraction: false }}
            pagination={{ clickable: true }}
            onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}
            breakpoints={{
              640: { slidesPerView: 1.15, spaceBetween: 16 },
              768: { slidesPerView: 1.6, spaceBetween: 18 },
              992: { slidesPerView: 2.2, spaceBetween: 20 },
              1200: { slidesPerView: 2.6, spaceBetween: 22 },
            }}
            className="gallerySwiper"
          >
            {images.map((img, idx) => (
              <SwiperSlide key={idx}>
                <article className="gallerySlide">
                  <div className="imgBox">
                    <img
                      src={img}
                      alt={`Evento Pixbae Banquetes ${idx + 1}`}
                      loading="lazy"
                    />
                    <div className="imgOverlay" />
                    <div className="caption">
                      {captions[idx % captions.length]}
                    </div>
                  </div>
                </article>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default Gallery;
